import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {chatBotKind, EXTRA_HV_CATEGORIES, versionOfHvCui, getDateTimeDescription} from 'helpers/ApplicationHelper';
import {InputSelect} from 'components/formElements';
import moment from 'moment';
import {convertDateTimeToLocalTime} from 'helpers/dateTimeHelper';
import {hvCuiSaveLog, highValueSaveLog, jewelryBoxSaveLog} from 'actions/item';
import {scheduleAppointment} from 'actions/user';
import I18n from 'lib/i18n/i18n';
import BaseChatBot from "../baseChatBot";

const START_TIME_INTERVAL_HOURS = 2;
const TIME_ZONE = 'America/New_York';

class ScheduleAppointment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            optionsPlaceHolder: {0: this.props.message.text},
            timeSlotOptions: {},
            chatBotType: props.chatBotType,
            objectId: props.objectId
        };

        this.onTimeSelect = this.onTimeSelect.bind(this);
        this._scheduleAppointment = this._scheduleAppointment.bind(this);

        props.promise.then(this._scheduleAppointment);
    }

    get callHours() {
        switch (this.props.chatBotType) {
            case 'highValue':
                return this.props.ADO.high_value_call_hours;
            case 'jewelryBox':
                return this.props.ADO.jb_call_hours;
            default:
                console.log('callHours not set for:' + this.props.chatBotType);
                itemSaveLog(this.props.Item.id, 'callHours not set for:' + this.props.chatBotType)
        }
    }

    get freeSlots() {
        switch (this.props.chatBotType) {
            case 'highValue':
                return this.props.ADO.high_value_free_slots;
            case 'jewelryBox':
                return this.props.ADO.jb_free_slots;
            default:
                console.log('freeSlots not set for:' + this.props.chatBotType);
                itemSaveLog(this.props.Item.id, 'freeSlots not set for:' + this.props.chatBotType)
        }
    }

    componentDidMount() {
        let day =  moment().format('dddd').toLowerCase(),
            numbersOfDaysToShow = this.callHours[day] || 2;
        this._generateTimeSlots({}, numbersOfDaysToShow);
    }


    /**
     * parmas: currentOptions - Item already in scheduled calls options list
     * numbersOfDaysToShow - the number of days to show on the menu
     *
     * this function generate available timeslots using a list from the Rails API
     * calculation done on server and not on client
     */
    _generateTimeSlots(currentOptions, numbersOfDaysToShow){

        const options = currentOptions ? Object.assign({0: this.props.message.text}, currentOptions) : {0: this.props.message.text},
              freeSlotsValues = this.freeSlots;
        for (let time_str of freeSlotsValues) {
            let time = moment(time_str);
            const start = time.clone().local().format('h:mma');
            if (time.diff(moment(),'days') >= numbersOfDaysToShow) {continue;}
            options[time.format()] = getDateTimeDescription(time, true);
        }
        if (Object.keys(options).length <= 1 && numbersOfDaysToShow < 7) {
            this._generateTimeSlots(options,numbersOfDaysToShow + 1)

        }
        else {
            let option_slots = Object.keys(options).slice(1),
                shownSlots= option_slots.join(),
                countSlots= option_slots.length,
                msg = `${countSlots} Time slots shown to the user (timezone: ${moment().tz(moment.tz.guess()).format('z ([GMT] Z)')}): ${shownSlots}`;
            if (this.props.chatBotType==='highValue') {
                this.props.highValueSaveLog(this.props.hvCuiVersion ,this.props.objectId, msg, false);
            }
            else{
                this.props.jewelryBoxSaveLog(this.props.objectId, this.props.hvCuiVersion , null, msg, true, 'histories');
            }
            this.setState({timeSlotOptions: options});
        }
    }

    onTimeSelect(message, selectedTime) {
        this.props.onTimeSelect(message, selectedTime);
        if (this.state.chatBotType === 'highValue') {
            this.props.hvCuiSaveLog(this.props.Item.id, this.props.hvCuiVersion, selectedTime,
                this.props.Item.hvCuiLastMessageKey, false, I18n.getString('itemPage::highValueEstimation::1::events::keys::timeSelected'));
        }
    }

    onClick() {
        if (this.state.chatBotType === 'highValue') {
            this.props.hvCuiSaveLog(this.props.Item.id, this.props.hvCuiVersion,
                I18n.getString('itemPage::highValueEstimation::1::events::messages::timeDropDownClicked'), this.props.Item.hvCuiLastMessageKey, false);
        }
    }

    _scheduleAppointment(selectedTime) {
        switch (selectedTime) {
            case 'Tomorrow':
                this._generateTimeSlots(convertDateTimeToLocalTime(TIME_ZONE, moment().add(1, 'days')));
                break;
            case 'Today':
                this._generateTimeSlots(convertDateTimeToLocalTime(TIME_ZONE, moment()));
                break;
        }
        let time = moment(selectedTime);
        let preferredTimeDate = convertDateTimeToLocalTime(TIME_ZONE, time);
        let preferredDayText = getDateTimeDescription(time);
        let preferredTimeText = time.format('h:mm a');
        return this.props.scheduleAppointment({
            appointmentDetails: {
                chatBotType: this.state.chatBotType,
                phone: this.props.Session.userData.phone || '',
                preferredDayText: preferredDayText,
                preferredTimeDate: preferredTimeDate,
                preferredTimeText: preferredTimeText,
                timezoneName: moment.tz.guess(),
                version: this.props.hvCuiVersion
            },
            objectId: this.state.objectId
        }).then(this.props.callback);
    }

    render(){
        return (
            <div id={this.props.id} className='message-input-container message-schedule-appointment absolute-position input-root'>
                <InputSelect
                    ref="inputDropDown"
                    type='select'
                    name="drop-down"
                    defaultValue={this.props.message.text}
                    options={this.state.timeSlotOptions}
                    onClick={this.onClick.bind(this)}
                    onFocus={this.props.onFocus}
                    onBlur={this.props.onBlur}
                    onBeforeChange={(selectedTime) => {this.onTimeSelect(this.props.message, selectedTime)}}
                />
            </div>
        );
    }
}

// Kindly borrowed from highValueEstimationB
const mapStateToProps = (state) => {
    const {
        ADO,
        Item,
        ChatBot,
        Personalized,
        Session
    } = state;
    // TODO: should be unified in one place or work via Store
    // This component is actually in use in 2 places: JB CUI and HV CUI so event versioning here needs adjustment
    const hvCuiVersion = versionOfHvCui(Personalized, ChatBot)

    return {
        Session,
        ADO,
        Item: Item,
        hvCuiVersion: hvCuiVersion
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({hvCuiSaveLog, highValueSaveLog, jewelryBoxSaveLog, scheduleAppointment}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleAppointment);
